// extracted by mini-css-extract-plugin
module.exports = {"container":"container___2JzEU","href":"href___2ko-Y","date":"date___JFOP8","authors":"authors___jfDHG","flex":"flex___1uFvk","time":"time___3YfH7","iconText":"iconText___2hTGQ"};